var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "option-panel",
    class: {
      'active': _vm.isActive
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('click', _vm.option);
      }
    }
  }, [_vm.option.icon ? _c('div', {
    staticClass: "icon-container"
  }, [_c('base-icon', {
    attrs: {
      "name": _vm.option.icon
    }
  })], 1) : _vm.$slots.hasOwnProperty('icon') ? [_vm._t("icon")] : _vm._e(), _c('div', {
    staticClass: "option-info"
  }, [_c('p', {
    staticClass: "option-description"
  }, [_vm._v(" " + _vm._s(_vm.option.description) + " ")]), _c('p', {
    staticClass: "option-label"
  }, [_vm._v(" " + _vm._s(_vm.option.label) + " ")])]), _vm.$slots.hasOwnProperty('default') ? _c('div', {
    staticClass: "option-slot",
    class: {
      single: _vm.hasSingleClass
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._t("default")], 2) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }